import { Link } from "react-router-dom";
import { useAuthStore } from "../auth";

export function Home() {
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

	return (
		<section className="max-w-3xl mx-auto text-center py-16">
			<h1 className="text-5xl font-bold tracking-tight text-slate-900">
				Shop the drop.
			</h1>
			<p className="mt-4 text-lg text-slate-600">
				A tiny storefront built as the system under test for XiTester's
				PR-based E2E testing. Browse a handful of real-feeling products,
				add to cart, and place an order.
			</p>
			<div className="mt-8 flex items-center justify-center gap-3">
				<Link
					to="/products"
					data-testid="home-shop-now"
					className="btn-primary"
				>
					Shop now
				</Link>
				{isAuthenticated() && (
					<Link
						to="/products"
						data-testid="home-continue"
						className="btn-secondary"
					>
						Continue shopping
					</Link>
				)}
			</div>
		</section>
	);
}

export default Home;
